
import Alert from '@/eventbus/alert';
import { AxiosError } from 'axios';
import Vue, { PropType } from 'vue';
import { VueConstructor } from 'vue/types/vue';

const NotificationPanel = (Vue as VueConstructor).extend({
  props: {
    notifications: {
      type: Array as PropType<Alert[]>,
      required: true,
    },
  },

  methods: {
    getFormattedError(error: AxiosError) {
      const jsonString = JSON.stringify(error);
      return this.tryFormatJson(jsonString);
    },
  },
});

export default NotificationPanel;
